<template>
  <footer class="footer-secondary">
    <div class="footer-secondary-container">
      <div class="svg-container">
        <kf-curve
          :inverse="true"
          curve-alignment="left"
          :curve-svg-color="backgroundColor"
        />
      </div>
      <div class="footer-top">
        <div class="footer-inner-top">
          <div class="grid grid-cols-12 w-full">
            <!-- First Column with meta-bottom (logos) -->
            <div class="col-span-12 md:col-span-3 mb-8 md:mb-0">
              <div class="meta-bottom" />
              <kf-logo :logo="mainLogo" />
            </div>

            <!-- Second Column with Contact Information -->
            <div class="col-span-12 md:col-span-3 mb-8 md:mb-0">
              <h3 v-if="labelFirst">
                {{ labelFirst }}
              </h3>
              <kf-list
                :is-white="true"
                :items="listFirst"
              />
            </div>

            <!-- Third Column with Quick Links -->
            <div class="col-span-12 md:col-span-3 mb-8 md:mb-0">
              <h3 v-if="labelSecond">
                {{ labelSecond }}
              </h3>
              <kf-list
                :is-white="true"
                :items="listSecond"
              />
            </div>

            <!-- Fourth Column with Quick Links -->
            <div class="col-span-12 md:col-span-3 mb-8 md:mb-0">
              <h3 v-if="labelThird">
                {{ labelThird }}
              </h3>
              <kf-list
                :is-white="true"
                :items="listThird"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="footer-inner-bottom">
        <div class="grid grid-cols-12 w-full">
          <div class="col-span-12 self-end md:self-start pb-8 md:pb-0">
            <div class="meta-top">
              <span
                v-if="copyright"
                class="meta-top-left"
              >
                {{ copyright }}
              </span>
              <span><a
                v-if="privacy"
                class="meta-top-right"
                :href="privacy.href"
              >
                {{ privacy.label }}
              </a></span>
            </div>
            <div class="meta-bottom">
              <div
                v-for="(logo, i) in footerLogos"
                :key="i"
              >
                <template v-if="logo.href">
                  <a
                    :href="logo.href"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      class="meta-bottom-image"
                      :src="logo.imageSrc"
                      :alt="logo.imageAlt"
                    >
                  </a>
                </template>
                <template v-else>
                  <img
                    class="meta-bottom-image"
                    :src="logo.imageSrc"
                    :alt="logo.imageAlt"
                  >
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import KfCurve from '@/components/base/curve/Curve.vue';
import KfList from '@/components/base/list/List.vue';
import KfLogo from '@/components/base/logo/Logo.vue';

export default {
  name: 'KfFooterSecondary',
  components: {
    KfList,
    KfLogo,
    KfCurve,
  },
  props: {
    backgroundColor: {
      type: String,
      default: 'white',
    },
    mainLogo: {
      type: String,
      default: null,
    },
    labelFirst: {
      type: String,
      default: null,
    },
    labelSecond: {
      type: String,
      default: null,
    },
    labelThird: {
      type: String,
      default: null,
    },
    listFirst: {
      type: Array,
      default: null,
    },
    listSecond: {
      type: Array,
      default: null,
    },
    listThird: {
      type: Array,
      default: null,
    },
    copyright: {
      type: String,
      default: null,
    },
    privacy: {
      type: Object,
      default: null,
    },
    socialData: {
      type: Array,
      default: null,
    },
    footerLogos: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="postcss">
.footer-secondary {
  @apply relative w-full;
  background: white;
  margin-top: auto;


  &-container {
    background: linear-gradient(to left, var(--color-primary-charlie), var(--color-primary-bravo));
  }

  .logo {
    transform: translate(0, 0); // prevents overlap styles from logo
  }

  h3 {
    color: white;
  }

  & .footer-top {
    @apply relative w-full pb-24 pt-20;
  }

  & .footer-inner-top {
    @apply relative w-full mx-auto flex container px-5 md:px-4;
  }

  & .footer-bottom {
    @apply pt-4 bg-transparent; /* Changed to transparent to let the gradient show through */

    @screen md {
      @apply pt-0;
    }
  }

  & .footer-inner-bottom {
    @apply relative w-full mx-auto flex container px-5 md:px-4;

    .meta {
      &-top {
        @apply flex flex-col md:flex-row items-center justify-start mb-4 pt-4 text-sm gap-6;

        &-left {
          @apply block md:inline text-sm mb-4;

          @screen md {
            @apply mb-0;
          }
        }

        &-right {
          @apply mr-0 md:mr-4 block md:inline-block mb-4 md:mb-0 text-sm;
        }
      }

      &-bottom {
        @apply flex flex-col md:flex-row items-center justify-end text-sm;

        @screen md {
          @apply pb-4;
        }

        &-image {
          @apply md:mr-4 mb-4 md:mb-0;
        }
      }
    }
  }
}
</style>
